var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-select',{attrs:{"items":_vm.teamOptions,"item-text":"name","item-value":"code","label":"Team"},model:{value:(_vm.team),callback:function ($$v) {_vm.team=$$v},expression:"team"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }